module.exports = __webpack_public_path__ + "img/dink-kitchen-2.cc4557ac.jpeg";